// One load of the Operations Report for every widget on the board that
// asks for the same dates. Each widget still renders its own slice.

import { loadOperationsReport } from './operationsReportApi'

const cache = new Map()

export function operationsReportCacheKey(domainId, from, to) {
  return `${domainId || ''}|${from}|${to}`
}

export function clearSharedOperationsReport() {
  cache.clear()
}

export function loadSharedOperationsReport({ from, to, domainId = '', fresh = false }) {
  const key = operationsReportCacheKey(domainId, from, to)
  if (fresh) cache.delete(key)
  if (!cache.has(key)) {
    const pending = loadOperationsReport({ from, to, compare: false }).catch((err) => {
      cache.delete(key)
      throw err
    })
    cache.set(key, pending)
  }
  return cache.get(key)
}
